import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { SelectedTableFiltersStateModel, SelectedTableFiltersFormValue } from '../../../model';

@State<SelectedTableFiltersStateModel>({
  name: 'selectedTableFilters',
  defaults: {
    selectedFiltersForm: {
      model: undefined,
      dirty: false,
      status: '',
      errors: {},
    },
  },
})
@Injectable()
export class SelectedTableFiltersState {
  @Selector()
  static applicationSelectorFormValues(state: SelectedTableFiltersStateModel): SelectedTableFiltersFormValue | undefined{
    return state.selectedFiltersForm.model;
  }
}
